import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/message/PZZL5GZ65EAIC1"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float fixed bottom-24 right-6 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition-all hover:scale-110 z-50 group"
      data-testid="whatsapp-button"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={28} className="animate-pulse" />
      
      {/* Tooltip */}
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-slate-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Chat with us on WhatsApp
      </span>
      
      {/* Pulse rings */}
      <span className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-75"></span>
      <span className="absolute inset-0 rounded-full bg-green-400 animate-pulse opacity-50"></span>
    </a>
  );
};

export default WhatsAppButton;